module.exports = __webpack_public_path__ + "img/color5.540a36cc.png";